import * as L from 'leaflet'
import { renderToString } from 'react-dom/server'
import { ReactComponent as Marker } from '../../../../assets/marker.svg'

const createMarker = (style) => renderToString(<div style={style}><Marker/></div>)

export const SearchMarkerIcon = new L.DivIcon({
  className: null,
  html: createMarker({ color: 'gray', stroke: 'white', strokeWidth: 2 }),
  iconAnchor: [15, 40],
  iconSize: [30, 40],
})

export const SIMarkerIcon = new L.DivIcon({
  className: null,
  html: createMarker({ color: '#4884ffff' }),
  iconAnchor: [15, 40],
  iconSize: [30, 40],
})

export const MarkerIcon = new L.DivIcon({
  className: null,
  html: createMarker({ color: '#ff4848ff' }),
  iconAnchor: [15, 40],
  iconSize: [30, 40],
})
